import { Injectable } from '@angular/core';
import { Guid } from '@app/shared/models/common/guid';
import * as pkg from '../../package.json';
import { EnvName } from './env-name';
import { IEnvironment } from './ienvironment';

const InputToBoolean = (input) => {
  if (typeof input === 'boolean') {
    return input;
  }
  else if (typeof input === 'string') {
    return input.toLowerCase() === 'true';
  }
  return false;
};

export const environment: IEnvironment = {
  apiUrl: "https://cem-api.plex.xom.cloud/api/",
  spmAppUrl: "https://spm.plex.xom.cloud",
  version: "2.0.0",
  security: true,
  production: false,
  hmr: true,
  pkg: pkg,
  buildDate: '2021-10-01',
  isSpm: false,
  envName: EnvName.prod,
  username: '',
  agGridLicense: "Using_this_{AG_Grid}_Enterprise_key_{AG-125314}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ExxonMobil_Global_Services_Company}_is_granted_a_{Multiple_Applications}_Developer_License_for_{16}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{1_March_2029}____[v3]_[01]_MTg2NzAxNzYwMDAwMA==80ffb5933b8c58285ac9a7c9d22678f7",
  id: '',
  showWellMappingTabFeatures: false,
  useNewEngine: true,
  showPdfDownloadButton: true,
  showPadConstructionParameters: true,
  showEstimateCompareButton: false,
  showDelawareBasin: true,
  hideAllButPATAndDELBasins: true,
  showPadConstructionSchedules: true,
  capitalForecastDefaultEffectiveDateOffset: 0,
  msalConfig: {
    auth: {
      clientId: "5aee429f-8125-472d-99fd-e1a6b6730e57",
      authority: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906/",
    },
  },
  apiConfig: {
    scopes: ["user.read", "profile"],
    uri: "https://graph.microsoft.com",
    accessScopes: [
      "api://ee9e35fb-ec6b-4ee3-aa82-02a667db2d17/plexapi.read",
      "api://ee9e35fb-ec6b-4ee3-aa82-02a667db2d17/plexapi.readwrite"
    ],
  },
  accessToken: '',
  appInsights: { 'instrumentationKey': "ec4d6ada-0ad1-4d22-bca6-4bdac2df5ddd" },
  executeUrl: "https://exxon.execute.aucerna.app/",
}

@Injectable({
  providedIn: 'root',
})
export class PlexEnvironment implements IEnvironment {
  id: string;
  production: boolean;
  apiUrl: string;
  spmAppUrl: string;
  hmr: boolean;
  public security: boolean;
  showWellMappingTabFeatures: boolean;
  isSpm: false;
  envName?: string;
  buildDate: string | Date;
  appInsights?: { instrumentationKey: string; };
  useNewEngine: boolean;
  showPdfDownloadButton: boolean;
  showPadConstructionParameters: boolean;
  showEstimateCompareButton: boolean;
  showDelawareBasin: boolean;
  hideAllButPATAndDELBasins: boolean;
  username: string;
  accessToken: string;    //send this to the API
  idToken: string;        //NEVER send this to the API, to be used by the client only
  accessTokenExpiresOn: Date | null;
  showPadConstructionSchedules: boolean;
  agGridLicense: string;
  capitalForecastDefaultEffectiveDateOffset: number;
  msalConfig: { auth: { clientId: string; authority: string; }; };
  apiConfig: { scopes: string[]; uri: string; accessScopes: string[] };
  executeUrl: string;

  private populated: boolean = false;

  private populate_internal(r: IEnvironment) {
    let environment = this;

    environment.id = Guid.NEW();

    environment.apiUrl = r.apiUrl;
    environment.isSpm = r.isSpm;
    environment.spmAppUrl = r.spmAppUrl;
    if (r.envName) {
      environment.envName = r.envName;
    }
    environment.security = InputToBoolean(r.security);

    environment.showWellMappingTabFeatures = InputToBoolean(r.showWellMappingTabFeatures);
    environment.useNewEngine = InputToBoolean(r.useNewEngine);
    environment.showPdfDownloadButton = InputToBoolean(r.showPdfDownloadButton);
    environment.showPadConstructionParameters = InputToBoolean(r.showPadConstructionParameters);
    environment.showPadConstructionSchedules = InputToBoolean(r.showPadConstructionSchedules);
    environment.showEstimateCompareButton = InputToBoolean(r.showEstimateCompareButton);
    environment.showDelawareBasin = InputToBoolean(r.showDelawareBasin);
    environment.hideAllButPATAndDELBasins = InputToBoolean(r.hideAllButPATAndDELBasins);
    environment.username = r.username;

    environment.appInsights = r.appInsights;

    environment.msalConfig = r.msalConfig;
    environment.apiConfig = r.apiConfig;

    environment.agGridLicense = environment.agGridLicense ?? r.agGridLicense;
    environment.executeUrl = r.executeUrl;
  }

  public populate(): void {
    if (this.populated) {
      throw new Error('cannot be populated more than one time');
    }
    this.populated = true;
    this.populate_internal(this);

  }

  constructor() {
    this.populate_internal(environment);
  }
  pkg: any;
  version: string;
}